const firebase = require('firebase')
const config = require('../firebase-config.json')
const axios = require('axios')

const registrationEndpoint = 'https://api.werksoft.net/eternal/dev/register/'

firebase.initializeApp(config)

const messaging = firebase.messaging()

export default {
  state: {
    eternalReady: false,
    firebaseReady: false,
    eternalError: '',
    firebaseToken: null,
    ephemeralToken: null,
    eternalToken: null,
    eternalMessages: []
  },
  getters: {
    firebaseToken: (state) => { return state.firebaseToken },
    eternalError: (state) => { return state.eternalError },
    firebaseReady: (state) => { return state.firebaseReady },
    ephemeralToken: (state) => { return state.ephemeralToken },
    eternalToken: (state) => { return state.eternalToken },
    eternalReady: (state) => { return state.eternalReady }
  },
  mutations: {
    pushMessage (state, payload) {
      state.eternalMessages.push(payload)
    },
    setFirebaseToken (state, {firebaseToken}) {
      state.firebaseToken = firebaseToken
    },
    setEphemeralTokens (state, payload) {
      state.ephemeralToken = payload.ephemeralToken
      state.eternalToken = payload.eternalToken
    },
    setFirebaseReady (state) {
      state.firebaseReady = true
    },
    setEternalReady (state) {
      state.eternalReady = true
    },
    setRecieverError (state, {message}) {
      state.eternalError = message
    }
  },
  actions: {
    registerFirebase ({dispatch, commit, state}) {
      if (state.firebaseReady) return

      navigator.serviceWorker.register('/static/service-worker.js')
      .then((registration) => {
        console.log('Service Worker Registered...')

        navigator.serviceWorker.onmessage = function (ev) {
          commit('pushMessage', ev.data)
          console.log(ev)
          if (ev.data['firebase-messaging-msg-data'].data.ephemeral_token !== undefined) {
            commit('setEphemeralTokens', {
              ephemeralToken: ev.data['firebase-messaging-msg-data'].data.ephemeral_token,
              eternalToken: ev.data['firebase-messaging-msg-data'].data.eternal_token
            })
            commit('setEternalReady')
          }
          return false
        }

        messaging.useServiceWorker(registration)
        messaging.requestPermission()
        .then(() => {
          console.log('Notification permission granted...')
          messaging.getToken()
          .then((newToken) => {
            if (newToken) {
              console.log('Instance firebaseToken obtained...')
              commit('setFirebaseToken', {firebaseToken: newToken})
              commit('setFirebaseReady')
              dispatch('registerEternal')
            } else {
              commit('setRecieverError', {message: 'No Instance ID Token available. Request permission to generate one.'})
            }
          })
          .catch((err) => {
            commit('setRecieverError', {message: 'Token Error: ' + err})
          })
        })
        .catch((err) => {
          commit('setRecieverError', {message: 'Permission Error: ' + err})
        })
      })
    },
    registerEternal ({commit, state}) {
      if (state.eternalReady || !state.firebaseReady) return
      console.log('Sending Message to Eternal...')
      var registrationData = {
        message_service_token: state.firebaseToken,
        platform: 'web',
        capabilities: [],
        profile_token: 'eternalmon test client',
        time: (new Date()).getTime()
      }

      axios.post(registrationEndpoint, registrationData)
      .then((result) => {
        console.log('Message Sent Sucessfully...')
        if (result.data) commit('setRecieverError', {message: result.data})
      })
      .catch((result) => {
        console.log('Message Sent With Error...')
        commit('setRecieverError', {message: result.data})
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/MockEphemeral.js